import React from "react"
import FieldProto_FormElement from "../../../../proto/render/form-element";
import DropdownFormView from "./components/form";

export default class FieldDropdown_FormElement extends FieldProto_FormElement {

    render() {
        return <DropdownFormView className      = {this.props.className}
                                 field          = {this.props.field}
                                 value          = {this.value}
                                 model          = {this.props.model}
                                 configOptions  = {this.props.options}
                                 disabled       = {this.props.disabled}
                                 onChange       = {this.onChange}/>
    }

}